module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../node_modules/happypack/loader.js?id=jsx!./ProductListView.js"));
	}, "LookGoodsHistoryView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=LookGoodsHistoryView!./src/pages/Promote/BusinessCard/ProductList/ProductListView.js
// module id = 1112
// module chunks = 438